module.exports = __webpack_public_path__ + "static/media/metafest-wanderer.f41876cd.png";